import template from "./select-cost-modal.html";

const SelectCostModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class CostListViewController {
    /* @ngInject */
    constructor($rootScope, $q, $filter, ModalsManager, Cost) {
      this.$rootScope = $rootScope;
      this.$q = $q;
      this.$filter = $filter;
      this.ModalsManager = ModalsManager;
      this.Cost = Cost;
    }

    async $onInit() {
      this.costs = [];
      this.costsCount = 0;
      this.searchOptions = {
        name: "",
        page: 1,
      };

      await this.refresh();
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.name,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            if (newVal.length === 0) this.refresh().then();
            else this.findBySearchText(this.searchOptions.name).then();
          }
        }
      );
    }

    selectCost(cost) {
      this.close({ $value: cost });
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }

    async findBySearchText() {
      this.loading = true;
      this.searchOptions.page = 1;
      const data = await this.$q
        .all({
          costPromise: this.Cost.query({
            q: this.searchOptions.name,
            page: this.searchOptions.page,
          }),
          costsCountPromise: this.Cost.getCount({ q: this.searchOptions.name }),
        })
        .then((values) => {
          return {
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async refresh() {
      this.searchOptions.name = "";
      await this.findBySearchText();
    }

    async loadMoreCosts() {
      const loadedCosts = this.costs.length;
      const costsToLoad = this.costsCount;
      if (loadedCosts < costsToLoad && !this.loading) {
        this.searchOptions.page++;
        const costs = await this.loadCosts();
        this.costs = this.costs.concat(costs);
        this.$rootScope.$applyAsync();
      }
    }

    async loadCosts() {
      this.loading = true;
      const costs = await this.Cost.query({
        q: this.searchOptions.name,
        page: this.searchOptions.page,
      });

      this.loading = false;
      this.$rootScope.$applyAsync();
      return costs;
    }

    async createCost() {
      if (await this.ModalsManager.openCostModal(new this.Cost()))
        await this.refresh();
    }
  },
};

export default SelectCostModalComponent;
